import { createConsumer } from '@rails/actioncable'

// Live notifications. The server broadcasts only the id of a new notification on
// the user's own stream, and the page asks for the toast itself: it is rendered by
// an ordinary request, and the bell in the same response is `[up-hungry]`, so the
// unread count goes up with it.
//
// The toast stack sits outside `[up-main]` and is rendered once per full page
// load, so there is one subscription per tab. It carries the URL only for somebody
// signed in, and signing out is a full page load, which closes the socket. How a
// toast shows and leaves is `toast_compiler.js`.
let consumer = null

up.compiler('#toasts[data-notification-toast-url]', (container) => {
  if (!consumer) consumer = createConsumer()

  const show = ({ id }) => {
    up.render({
      target: '#toasts:after',
      url: container.dataset.notificationToastUrl.replace('__id__', id),
      layer: 'root',
      cache: false,
      history: false,
    }).then(() => {
      up.emit('notifications:arrived')
    }).catch(() => {
      // A notification deleted before the tab asked for it answers 404. Nothing
      // waits on this, and an uncaught rejection would surface as a console error.
    })
  }

  // `data-connected` says the subscription is confirmed. A broadcast made before
  // that reaches nobody, so a scenario waits for it before creating one.
  const subscription = consumer.subscriptions.create('NotificationsChannel', {
    received: show,
    connected: () => { container.dataset.connected = 'true' },
    disconnected: () => { delete container.dataset.connected },
  })

  return () => subscription.unsubscribe()
})
